import { render, staticRenderFns } from "./DetailCampusCards.vue?vue&type=template&id=1acd642d"
import script from "./DetailCampusCards.vue?vue&type=script&lang=js"
export * from "./DetailCampusCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports